var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5889 3.99408C10.2635 3.66864 9.73586 3.66864 9.41042 3.99408L6.07709 7.32741C5.75165 7.65285 5.75165 8.18049 6.07709 8.50592C6.40252 8.83136 6.93016 8.83136 7.2556 8.50592L9.99967 5.76184L12.7438 8.50592C13.0692 8.83136 13.5968 8.83136 13.9223 8.50592C14.2477 8.18049 14.2477 7.65285 13.9223 7.32741L10.5889 3.99408ZM13.9223 12.6726L10.5889 16.0059C10.2635 16.3314 9.73586 16.3314 9.41042 16.0059L6.07709 12.6726C5.75165 12.3472 5.75165 11.8195 6.07709 11.4941C6.40252 11.1686 6.93016 11.1686 7.2556 11.4941L9.99967 14.2382L12.7438 11.4941C13.0692 11.1686 13.5968 11.1686 13.9223 11.4941C14.2477 11.8195 14.2477 12.3472 13.9223 12.6726Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.eb708421ea981f4ba05d42a1595b0d88.svg";
export { ForwardRef as ReactComponent };